module.exports = __webpack_public_path__ + "img/anl1.e7d9ec58.png";